import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import {
  useGetPayrollStagingDetailQuery,
  useRecalculatePayrollStageMutation,
  useStagingPayrollMutation,
  useUpdatePayrollStageMutation,
} from "AppQuries/payroll/staging";
import { FormProvider, useForm } from "react-hook-form";
import PayrollForm from "Components/Form/PayrollForm";
import PayrollAdditionDeductionForm from "Components/Form/PayrollAdditionDeduction";
import Swal from "sweetalert2";
import { endOfMonth, startOfMonth, format } from "date-fns";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useReGeneratePayrollMutation } from "AppQuries/payroll/generate-payroll";
import { toast } from "core/Operations/toast";
import { Save, RefreshCcw } from "react-feather";
import MonthlyEdit from "./payroll/MonthlyEdit";
import HourlyEdit from "./payroll/HourlyEdit";

// import { RefreshCcw } from "feather-icons-react/build/IconComponents";
const ViewPayrollStaging = () => {
  const userData = useSelector(loggedInUser);
  const { code } = useParams();
  const [isReGenerated, setIsReGenerated] = useState(false);
  const methods = useForm({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    userName: userData?.userName,
  });
  const navigate = useNavigate();
  const {
    setValue,
    handleSubmit,
    formState: { errors },
  } = methods;

  const [filter, setFilter] = useState({
    companyCode: userData.companyCode,
    locationCode: userData.selectedLocationCode,
    employeeCode: 0,
    refNo: code,
  });

  const [payrollData, setPayrollData] = useState({});
  const [newPayrollData, setNewPayrollData] = useState([]);

  const {
    mutate: stagingPayroll,
    isError,
    error,
    isPending,
    isFetching,
  } = useStagingPayrollMutation();

  const {
    data: payrollStagingDetail,
    isFetching: isFetchingPayrollStagingDetail,
    isError: isPayrollStagingDetailError,
    error: payrollStagingDetailError,
    refetch: refetchPayrollStagingDetail,
  } = useGetPayrollStagingDetailQuery(
    { ...filter },
    {
      enabled: !!code && !!filter.companyCode && !!filter.locationCode,
    }
  );

  const { data: employees } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
  });

  const { mutate: reGeneratePayroll } = useReGeneratePayrollMutation();

  const submitPayroll = () => {
    Swal.fire({
      title: "Confirm to submit?",
      text: "Are you sure you want re-submit payroll",
      type: "warning",
      showCancelButton: !0,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn btn-danger ml-1",
      buttonsStyling: 1,
      buttons: ["No", "Yes"],
    }).then(function (t) {
      if (t.isConfirmed) {
        console.log("payrollData", payrollData);
        let jsonData = [];
        // const selectedPayrollData = payrollData.filter((payroll) =>
        //   selectedRowKeys.includes(payroll.employeeCode)
        // );

        newPayrollData?.forEach((payroll) => {
          jsonData.push({
            companyCode: payroll.companyCode,
            locationCode: payroll.locationCode || userData.locationCode,
            refNo: payroll.refNo,
            employeeCode: payroll.employeeCode,
            icno: payroll.icNo,
            processDateStr: format(new Date(), "yyyy-MM-dd"),
            procesMonth: Number(payroll.procesMonth),
            processYear: Number(payroll.processYear),
            paymentCode: Number(payroll.paymentCode),
            departmentCode: Number(payroll.departmentCode),
            monthlySalary: Number(payroll.monthlySalary),
            basicSalary: Number(payroll.basicSalary),
            grossSalary: Number(payroll.grossSalary),
            addition: Number(payroll.addition),
            deduction: Number(payroll.deduction),

            // totalCpf: Number(payroll.totalCPF),
            // employeeCpf: Number(payroll.employeeCPF),
            // employerCpf: Number(payroll.employerCPF),
            totalCpf: Number(payroll.totalPercentage) ?? 0,
            employeeCpf: Number(payroll.employeePercentage) ?? 0,
            employerCpf: Number(payroll.employerPercentage) ?? 0,
            leaveTakenInDays: Number(payroll.leaveTakenInDays),
            leaveSalaryAmount: Number(payroll.leaveSalaryAmount),
            netPay: Number(payroll.netPay),
            contributionCode: payroll.contributionCode,
            agencyAmount: Number(payroll.agencyAmount),
            sdlAmount: Number(payroll.sdlAmount),
            noOfDaysInMonth: Number(payroll.noOfDaysInMonth),
            noOfWorkingDays: Number(payroll.noOfDaysInMonth),
            hourlySalary: Number(payroll.hourlySalary),
            additionalHours: Number(payroll.additionalHours),
            deductionHours: Number(payroll.deductionHours),
            otHourlySalary: Number(payroll.otHourlySalary),
            noOfOTWorkingDays: Number(payroll.noOfOTWorkingDays),
            // otDaySalary: Number(payroll.otDaySalary),
            otDaySalary: payroll.noOfOTWorkingDaysSalary,
            payrollValue: Number(payroll.payrollValue),
            salaryPayable: Number(payroll.salaryPayable),
            createUser: userData.createUser,
            extraorlessHourAmount: Number(payroll.extraorlessHourAmt),
            daySalary: Number(payroll.daySalary),
            payrollDetail: payroll.payrollDetails, //.length > 0 ? payroll.payrollDetail.map(d => ( {...d})) : []
            waitingTime: Number(payroll.waitingTime) ?? 0,
            waitingTimeSalary: Number(payroll.waitingTimeSalary) ?? 0,
            advancePayment: Number(payroll.advancePayment) ?? 0,
            normalWorkingHoursInMonth:
              Number(payroll.normalWorkingHoursInMonth) ?? 0,
            normalWorkingHoursSalary:
              Number(payroll.normalWorkingHoursSalary) ?? 0,
            oT1Hours: Number(payroll.oT1Hours) ?? 0,
            oT1HourlySalary: Number(payroll.oT1HourlySalary) ?? 0,
            oT2Hours: Number(payroll.oT2Hours) ?? 0,
            oT2HourlySalary: Number(payroll.oT2HourlySalary) ?? 0,
            extraHours: Number(payroll.extraHours) ?? 0,
            extraHoursSalary: Number(payroll.extraHoursSalary) ?? 0,
            publicHolidayOTHours: Number(payroll.publicHolidayOTHours) ?? 0,
            publicHolidayOTHoursSalary:
              Number(payroll.publicHolidayOTHoursSalary) ?? 0,
            paidLeaveDays: Number(payroll.paidLeaveDays) ?? 0,
            paidLeaveSalary: Number(payroll.paidLeaveSalary) ?? 0,
            publicHolidayHours: Number(payroll.publicHolidayHours) ?? 0,
            publicHolidayHoursSalary:
              Number(payroll.publicHolidayHoursSalary) ?? 0,
            leaveAmount: Number(payroll.leaveAmount) ?? 0,
            employeePercentage: Number(payroll.employeePercentage) ?? 0,
            employerPercentage: Number(payroll.employerPercentage) ?? 0,
            levyAmount: Number(payroll.levyAmount) ?? 0,
            payMonth: payroll.payMonth,
          });
        });

        stagingPayroll(jsonData, {
          onSuccess: (response) => {
            if (response[0].response === true) {
              Swal.fire({
                type: "success",
                title: "Payroll Re-Generated!",
                text: "Payroll Re-Generated Successfully..",
                confirmButtonClass: "btn btn-success",
              }).then(function (t) {
                navigate(`${all_routes.payroll}${all_routes.payroll_stage}`);
              });
            } else {
              Swal.fire({
                title: "Warning!",
                text: response[0].errorMessage,
                type: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
                confirmButtonClass: "btn btn-primary",
                okButtonClass: "",
                buttonsStyling: 1,
              });
            }
          },
        });
      }
    });

    setIsReGenerated(false);
  };

  const reCalculate = () => {
    const payload = {
      companyCode: payrollData?.companyCode || 0,
      month: payrollData?.procesMonth.toString() || "",
      year: payrollData?.processYear.toString() || "",
      userCode: userData.userCode || "",
      locationCode: payrollData?.locationCode || 0,
      salaryType: payrollData?.salaryType || 0,
      departmentCode: payrollData?.departmentCode || 0,
      employeeCode: payrollData?.employeeCode || 0,
    };

    reGeneratePayroll(payload, {
      onSuccess: (response) => {
        if (response.length > 0) {
          toast.success("Payroll Recalculated Successfully.");
          setIsReGenerated(true);
          setPayrollData(response[0]);
          setNewPayrollData(response);
          //   navigate(0);
        } else {
          toast.error("Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };

  const [settingData, setSettingData] = useState(true);
  useEffect(() => {
    if (payrollStagingDetail?.length > 0) {
      setPayrollData(payrollStagingDetail[0]);
      setSettingData(false);
    }
  }, [payrollStagingDetail]);

  if (isFetchingPayrollStagingDetail || settingData) return <LoadingSpinner />;
  // if (isError) return <Error404 error={error} />;
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>View Payroll Staging</h4>
                {/* <h6>Monthly Payroll Summary </h6> */}
              </div>
            </div>
            <div className="page-btn">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
              >
                <Link
                  className="btn btn-secondary"
                  to={`${all_routes.payroll}${all_routes.payroll_stage}`}
                >
                  <i className="fa fa-reply me-2" />
                  Back
                </Link>
              </OverlayTrigger>
            </div>
          </div>
          {payrollData?.salaryType === "Monthly" ? (
            <MonthlyEdit payrollData={payrollData} companyDetails={userData?.companyDetails} />
          ) : (
            <HourlyEdit payrollData={payrollData} companyDetails={userData?.companyDetails} />
          )}
        </div>
      </div>
    </>
  );
};

export default ViewPayrollStaging;
